var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass: "change-button",
      on: {
        click: function ($event) {
          _vm.showModal = true
        },
      },
    },
    [
      _vm._v("\n    " + _vm._s(_vm.$t("label.notifySettings")) + "\n    "),
      _c(
        "b-modal",
        {
          staticClass:
            "justify-content-center align-items-center notify-settings-modal-window",
          attrs: { centered: "", title: _vm.$t("label.notifySettings") },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _vm.isTeacher
            ? _c(
                "div",
                {
                  staticClass:
                    "notify-settings-modal justify-content-center d-flex",
                },
                [
                  _c("div", { staticClass: "font-weight-light mb-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("notificationType.newSolution")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox", {
                    staticClass: "notify-settings-checkbox",
                    attrs: { switch: "" },
                    on: { change: _vm.handleNotificationSettings },
                    model: {
                      value: _vm.notifications.newSolution,
                      callback: function ($$v) {
                        _vm.$set(_vm.notifications, "newSolution", $$v)
                      },
                      expression: "notifications.newSolution",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isTeacher
            ? _c(
                "div",
                {
                  staticClass:
                    "notify-settings-modal justify-content-center d-flex",
                },
                [
                  _c("div", { staticClass: "font-weight-light mb-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("notificationType.newComment")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox", {
                    staticClass: "notify-settings-checkbox",
                    attrs: { switch: "" },
                    on: { change: _vm.handleNotificationSettings },
                    model: {
                      value: _vm.notifications.newComment,
                      callback: function ($$v) {
                        _vm.$set(_vm.notifications, "newComment", $$v)
                      },
                      expression: "notifications.newComment",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTeacher
            ? _c(
                "div",
                {
                  staticClass:
                    "notify-settings-modal justify-content-center d-flex",
                },
                [
                  _c("div", { staticClass: "font-weight-light mb-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("notificationType.newQuestion")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox", {
                    staticClass: "notify-settings-checkbox",
                    attrs: { switch: "" },
                    on: { change: _vm.handleNotificationSettings },
                    model: {
                      value: _vm.notifications.newQuestion,
                      callback: function ($$v) {
                        _vm.$set(_vm.notifications, "newQuestion", $$v)
                      },
                      expression: "notifications.newQuestion",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "notify-settings-modal justify-content-center d-flex",
            },
            [
              _c("div", { staticClass: "font-weight-light mb-2" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("notificationType.contestNotifyStarted")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("b-form-checkbox", {
                staticClass: "notify-settings-checkbox",
                attrs: { switch: "" },
                on: { change: _vm.handleNotificationSettings },
                model: {
                  value: _vm.notifications.contestNotifyStarted,
                  callback: function ($$v) {
                    _vm.$set(_vm.notifications, "contestNotifyStarted", $$v)
                  },
                  expression: "notifications.contestNotifyStarted",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "notify-settings-modal justify-content-center d-flex",
            },
            [
              _c("div", { staticClass: "font-weight-light mb-2" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("notificationType.contestNotifyStart")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("b-form-checkbox", {
                staticClass: "notify-settings-checkbox",
                attrs: { switch: "" },
                on: { change: _vm.handleNotificationSettings },
                model: {
                  value: _vm.notifications.contestNotifyStart,
                  callback: function ($$v) {
                    _vm.$set(_vm.notifications, "contestNotifyStart", $$v)
                  },
                  expression: "notifications.contestNotifyStart",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "notify-settings-modal justify-content-center d-flex",
            },
            [
              _c("div", { staticClass: "font-weight-light mb-2" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("notificationType.contestNotifyEnd")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("b-form-checkbox", {
                staticClass: "notify-settings-checkbox",
                attrs: { switch: "" },
                on: { change: _vm.handleNotificationSettings },
                model: {
                  value: _vm.notifications.contestNotifyEnd,
                  callback: function ($$v) {
                    _vm.$set(_vm.notifications, "contestNotifyEnd", $$v)
                  },
                  expression: "notifications.contestNotifyEnd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "notify-settings-modal justify-content-center d-flex",
            },
            [
              _c("div", { staticClass: "font-weight-light mb-2" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("notificationType.groupStats")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("b-form-checkbox", {
                staticClass: "notify-settings-checkbox",
                attrs: { switch: "" },
                on: { change: _vm.handleNotificationSettings },
                model: {
                  value: _vm.notifications.groupStats,
                  callback: function ($$v) {
                    _vm.$set(_vm.notifications, "groupStats", $$v)
                  },
                  expression: "notifications.groupStats",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "notify-settings-modal justify-content-center d-flex",
            },
            [
              _c("div", { staticClass: "font-weight-light mb-2" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.isTeacher
                        ? _vm.$t("notificationType.groupCourse")
                        : _vm.$t("notificationType.groupCourseStudent")
                    ) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("b-form-checkbox", {
                staticClass: "notify-settings-checkbox",
                attrs: { switch: "" },
                on: { change: _vm.handleNotificationSettings },
                model: {
                  value: _vm.notifications.groupMailing,
                  callback: function ($$v) {
                    _vm.$set(_vm.notifications, "groupMailing", $$v)
                  },
                  expression: "notifications.groupMailing",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isTeacher
            ? _c(
                "div",
                {
                  staticClass:
                    "notify-settings-modal justify-content-center d-flex",
                },
                [
                  _c("div", { staticClass: "font-weight-light mb-2" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("notificationType.groupEntryLeave")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox", {
                    staticClass: "notify-settings-checkbox",
                    attrs: { switch: "" },
                    on: { change: _vm.handleNotificationSettings },
                    model: {
                      value: _vm.notifications.groupJoinLeave,
                      callback: function ($$v) {
                        _vm.$set(_vm.notifications, "groupJoinLeave", $$v)
                      },
                      expression: "notifications.groupJoinLeave",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }